/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Field, Form, Formik } from "formik";
import { Helmet } from "react-helmet";
import { connect, useSelector } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
// images
import superagent from "superagent";
import { Col, Row } from "reactstrap";
import { Container, InputGroup } from "react-bootstrap";
import gradient from "../../assets/images/bg/gredient.png";
import menuBg from "../../assets/images/bg/menu/resources.svg";
import email from "../../assets/images/icons/email.svg";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";
import FooterBottom from "../../components/footerBottom";
import SubmitLoader from "../../components/SubmitLoader";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
// actions
import { signupAction } from "./actions";
import "./style.scss";
import Loader from "../../components/loader";
import { base_url } from "../../utils/constants";
import { regex } from "../../utils/regex";
import { fetchCaptchaResponse } from "../../utils/request";
import CustomButton from "../../components/Buttons/CustomButton";
import useReactRefresh from "../../hooks/useReactRefresh";

const cookie = new Cookies();
const validationSchema = Yup.object({
  email: Yup.string()
    .required("Email can not be empty")
    .email("Email must be a valid email address")
    .matches(regex.email, "Email must be a valid email address"),
  fname: Yup.string().required("First Name can not be empty"),
  lname: Yup.string().required("Last Name can not be empty"),
  password: Yup.string()
    .required("Password can not be empty")
    .matches(regex.password, "Password must include minimum 8 characters with one uppercase, one special character and one numeric value."),
  reEnter_password: Yup.string()
    .required("Confirm password can not be empty")
    .oneOf([Yup.ref("password"), null], "Password does not match"),
  accept_terms: Yup.bool().required("Please accept the BAA and Terms of Use.").oneOf([true], "Please accept the BAA and Terms of Use."),
});

function Signup(props) {
  const [openMenu, setOpenMenu] = useState(false);
  const [ipAddress, getIpAddress] = useState("");
  const [showError, setShowError] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [state, setState] = useState({
    show_pass: false,
    con_pass: false,
  });
  const params = new URLSearchParams(document.location.search.substring(1));
  const code = params.get("refer");
  const redirectUrl = params.get("redirect_url");
  const trial = params.get("free-trial");
  const userEmail = params.get("email");
  const user_info = useSelector((state) => state?.my_account?.user_info);
  const userLoading = useSelector((state) => state?.my_account?.userLoader);
  const location = useLocation();
  const stripValue = location?.state === "fromFreeTrial" || trial === "true";

  const couponString = typeof location?.state === "object" ? `${location?.state?.location}${location?.state?.search}` : "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  useEffect(() => {
    cookie.remove("verify_email");
    // eslint-disable-next-line prettier/prettier
    if (
      user_info?.auth_token &&
      user_info?.type !== "trial" &&
      user_info?.is_free_trial !== 1 &&
      user_info?.subscription_type !== "PRO" &&
      user_info?.subscription_type !== "PRO_MONTH" &&
      user_info?.email_verified_at &&
      trial === "true" &&
      user_info?.is_pro === 0
    ) {
      superagent
        .get(`${base_url}trial-subscription?plan=PRO&type=free-trial`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else if (cookie.get("user_token")) {
      window.location = "/";
    }
    fetch("https://api.ipify.org?format=json")
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        getIpAddress(res.ip);
      })
      .catch((err) => console.error("Problem fetching my IP", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialState = {
    fname: "",
    lname: "",
    email: userEmail || "",
    password: "",
    reEnter_password: "",
    accept_terms: false,
  };
  const handleSubmit = (values, actions) => {
    if (!isCaptchaVerified) {
      setShowError(true);
      return;
    }
    const data = {
      fname: values.fname,
      lname: values.lname,
      email: values.email,
      password: values.password,
      accept_terms: values.accept_terms,
      ip: ipAddress,
      code: code || "",

      // type: stripValue ? "free trial" : ""
    };
    if (couponString) {
      data.coupon = couponString;
    }
    if (stripValue) {
      data.type = "free-trial";
    }
    if (redirectUrl) {
      data.redirect_url = encodeURIComponent(redirectUrl) || "";
    }
    props.signupAction(data, actions, props.history);
  };

  const errorHandler = (values) => {
    if (!values.accept_terms) {
      setShowError(true);
    }
  };
  const verifyCaptcha = useCallback(async (token) => {
    if (!token) {
      setIsCaptchaVerified(false);
      return;
    }
    const data = await fetchCaptchaResponse(token);
    if (data?.status) {
      setIsCaptchaVerified(true);
    }
  }, []);

  const redirectTo = useMemo(() => {
    return redirectUrl ? `?redirect_url=${encodeURIComponent(redirectUrl)}` : "";
  }, [redirectUrl]);

  useReactRefresh();

  return (
    <>
      <Helmet>
        <title>Sign Up For Free - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />

      {userLoading ? (
        <Loader />
      ) : (
        <div
          style={{
            background: `url(${gradient}) no-repeat center center / cover`,
          }}
          className="d-none"
        >
          <div className="w-100 h-100">
            <Container className="my-5 py-5">
              <Row className="justify-content-center">
                <Col md={10} lg={8} xl={6}>
                  <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
                    {({ values, handleChange, handleBlur, errors, touched }) => {
                      return (
                        <Form className="loginForm" autoComplete="off">
                          <h1 className="text-white loginTitle">Sign Up For Free</h1>
                          <p className="loginContent">You take care of others all day. Let us take care of you.</p>
                          <div className="accountCard">
                            <Row className="gy-3">
                              <Col xs={12} md={6}>
                                <Field
                                  id="fname"
                                  className="form-control"
                                  name="fname"
                                  value={values.fname}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="First Name*"
                                  autoComplete="off"
                                />
                                {touched.fname && errors.fname && <div className="errorMessage">{errors.fname}</div>}
                              </Col>
                              <Col xs={12} md={6}>
                                <Field
                                  id="lname"
                                  name="lname"
                                  className="form-control"
                                  value={values.lname}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Last Name*"
                                  autoComplete="off"
                                />
                                {touched.lname && errors.lname && <div className="errorMessage">{errors.lname}</div>}
                              </Col>
                            </Row>
                            <div className="my-2">
                              <InputGroup>
                                <Field
                                  id="email"
                                  name="email"
                                  value={values.email}
                                  className="form-control"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="E-mail*"
                                  icons={email}
                                  autoComplete="off"
                                />
                                <InputGroup.Text>
                                  <i className="fa-regular fa-fw fa-envelope" />
                                </InputGroup.Text>
                              </InputGroup>
                              {touched.email && errors.email && <div className="errorMessage">{errors.email}</div>}
                            </div>
                            <div className="my-2">
                              <InputGroup>
                                <Field
                                  id="password"
                                  name="password"
                                  className="form-control"
                                  value={values.password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Choose Password*"
                                  icons={!state.show_pass ? eye_visible : eye_Invisible}
                                  type={state.show_pass ? "text" : "password"}
                                  maxLength={25}
                                  autoComplete="off"
                                />
                                <InputGroup.Text
                                  className="cursor-pointer"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      show_pass: !state.show_pass,
                                    })
                                  }
                                >
                                  <i className={`fa-regular fa-fw ${state.show_pass ? "fa-eye-slash" : "fa-eye"}`} />
                                </InputGroup.Text>
                              </InputGroup>
                              {touched.password && errors.password && <div className="errorMessage">{errors.password}</div>}
                            </div>
                            <div className="my-2">
                              <InputGroup>
                                <Field
                                  id="reEnter_password"
                                  name="reEnter_password"
                                  className="form-control"
                                  value={values.reEnter_password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Re-enter Password*"
                                  icons={!state.con_pass ? eye_visible : eye_Invisible}
                                  type={state.con_pass ? "text" : "password"}
                                  showPassHandler={() =>
                                    setState({
                                      ...state,
                                      con_pass: !state.con_pass,
                                    })
                                  }
                                  maxLength={25}
                                />
                                <InputGroup.Text
                                  className="cursor-pointer"
                                  onClick={() =>
                                    setState({
                                      ...state,
                                      con_pass: !state.con_pass,
                                    })
                                  }
                                >
                                  <i className={`fa-regular fa-fw ${state.con_pass ? "fa-eye-slash" : "fa-eye"}`} />
                                </InputGroup.Text>
                              </InputGroup>
                              {touched.reEnter_password && errors.reEnter_password && <div className="errorMessage">{errors.reEnter_password}</div>}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="form-check">
                              <Field
                                type="checkbox"
                                className="form-check-input"
                                id="accept_terms"
                                name="accept_terms"
                                onChange={handleChange}
                                checked={values.accept_terms}
                              />
                              <label className="form-check-label cursor-pointer" htmlFor="accept_terms">
                                I agree to the{" "}
                                <a href="/business-associate-agreement" className="underline text-info" target="_blank" rel="noreferrer">
                                  BAA
                                </a>{" "}
                                and{" "}
                                <a href="/terms-of-service" className="underline text-info" target="_blank" rel="noreferrer">
                                  Terms of Use.
                                </a>
                              </label>
                            </div>
                            <a className="forgotPassword" style={{ color: "#8170EA" }} href={`/login${redirectTo}`} aria-label="Already a member? Log In Here">
                              Already a member? Log In Here
                            </a>
                          </div>
                          {showError && <div style={{ color: "#b00020" }}>{errors.accept_terms}</div>}
                          <div className="mt-3">
                            <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ""} onChange={verifyCaptcha} />
                            {showError && !isCaptchaVerified && <div style={{ color: "#b00020" }}>Please enter valid reCAPTCHA</div>}
                          </div>

                          <div className="d-flex justify-content-between align-items-center">
                            <CustomButton
                              variant="insurance"
                              className="mt-4"
                              type="submit"
                              onClick={() => errorHandler(values)}
                              disabled={props.meta.isLoading}
                              gradient
                            >
                              {props.meta.isLoading ? (
                                <>
                                  Sending... <SubmitLoader />
                                </>
                              ) : (
                                <>Create Account</>
                              )}
                            </CustomButton>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </Col>
              </Row>
            </Container>
            <p className="px-4 text-white text-xl d-flex justify-content-between fw-bold">JOIN THE FAMILY</p>
            <div style={{ width: "20%" }} className="signupProgressBar" />
          </div>
        </div>
      )}

      <FooterBottom />
    </>
  );
}

const mapStateToProps = (state) => ({
  meta: state.meta,
});

export default connect(mapStateToProps, { signupAction })(withRouter(Signup));
